import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import { useTheme } from '../theme';
import Icon from './Icon';

type AlertVariant = 'default' | 'success' | 'warn' | 'danger' | 'info';
const ICON_FOR: Record<AlertVariant, string> = { default: 'info', success: 'check', warn: 'warn', danger: 'warn', info: 'info' };

interface AlertProps {
  variant?: AlertVariant;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}

/** RN port of theme.css's .t-alert — icon + content callout, semantic soft variants. */
export default function Alert({ variant = 'default', children, style }: AlertProps) {
  const t = useTheme();
  const c = t.colors;
  const map: Record<AlertVariant, [string, string, string]> = {
    default: [c.paper2, c.line, c.ink2],
    success: [c.successSoft, c.successLine, c.success],
    warn: [c.warnSoft, c.warnLine, c.warn],
    danger: [c.dangerSoft, c.dangerLine, c.danger],
    info: [c.infoSoft, c.infoLine, c.info],
  };
  const [bg, border, fg] = map[variant];
  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: 10,
          padding: 12,
          borderWidth: 1,
          borderColor: border,
          backgroundColor: bg,
          borderRadius: t.radii[3],
        },
        style,
      ]}
    >
      <Icon name={ICON_FOR[variant]} size={16} strokeWidth={1.8} color={fg} style={{ marginTop: 1 }} />
      <View style={{ flex: 1 }}>{children}</View>
    </View>
  );
}
